import { Dialog, DialogContent, DialogTitle } from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import { useEffect, useState } from "react";
import CloseIcon from "@mui/icons-material/Close";
import { ls } from "../variables";
import { useLocation, useNavigate } from "react-router-dom";
import axios from "axios";
import { encrypt } from "../utils/cipher";
import { useStateValue } from "../Hooks/stateProvider";
import Styles from "./styles/selectComponentStyles.module.css";
import { LightTooltip } from "./LightTooltip";
import { errorHandler } from "../utils/errorHandling";
import { alert } from "../utils/sweetAlert";
import DataGridStyles from "./styles/viewCard.module.css";
import Loader from "../Loader/Loader";

const ViewHistory = ({ openModal, setOpenModal, selectedReportType }) => {
  const [{ moduleType,quarter,fy_year, pmsName, SEBITrackerPageData, SEBITrackerData }, dispatch] =
    useStateValue();
  const navigate = useNavigate();

  const [rows, setRows] = useState([]);
  const [complianceType, setComplianceType] = useState("");
  const location = useLocation();

  const downloadReport = async (uploadS3FilePath) => {
    if (uploadS3FilePath == undefined || uploadS3FilePath == "") {
      alert("Sorry!!", "No File Found", "error");
      return;
    }
    const downloadPayload = {
      s3Location: uploadS3FilePath,
      moduleType: moduleType,
      authToken: ls.get("authToken"),
      refreshToken: ls.get("refreshToken"),
    };
    const encryptedPayload = await encrypt(downloadPayload);
    const result = axios.post(
      "/api/pms/downloadReport",
      { payload: encryptedPayload },
      {
        withCredentials: true,
      }
    );
    result
      .then((response) => {
        if (response.data.success) {
          window.open(response.data.data, "_self");
        }
      })
      .catch((err) => {
        errorHandler(err, navigate);
      });
  };

  const alertColumns = [
    {
      field: "date",
      headerName: "Date",
      minWidth: 100,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      align: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return <>{params.row.date}</>;
      },
    },
    {
      field: "commentBy",
      headerName: "Comment By",
      minWidth: 130,
      flex: 1.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            {params.row.pmscomments
              ? "PMS"
              : "SEBI"}
          </>
        );
      },
    },
    {
      field: "instancecount",
      headerName: "Case ID Count",
      minWidth: 150,
      flex: 1.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <>
            {params.row.instancecount}
          </>
        );
      },
    },
    {
      field: "comment",
      headerName: "Comments",
      minWidth: 300,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              minHeight: "2rem",
              maxHeight: "5rem",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "auto",
              width: "100%",
              textAlign: "center"
            }}
          >
            {params.row.pmscomments
              ? params.row?.pmscomments
              : params.row?.sebicomments}
          </div>
        );
      },
    },
    {
      field: "ppaComments",
      headerName: "Proposed Plan of Action",
      minWidth: 300,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              minHeight: "2rem",
              maxHeight: "5rem",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "auto",
              width: "100%",
              textAlign: "center"
            }}
          >
            {params.row.proposedplanofaction
              ? params.row.proposedplanofaction
              : "-"}
          </div>
        );
      },
    },
    {
      field: "downloadSupportDoc",
      headerName: "",
      minWidth: 150,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params, index) => {
        return (
          <LightTooltip
            title={
              params.row.s3Location == undefined || params.row.s3Location == ""
                ? "No Files attached."
                : ""
            }
          >
            <span>
              <button
                className={Styles.Preview}
                key={index}
                style={{
                  backgroundColor:
                    params.row.s3Location == undefined ||
                      params.row.s3Location == ""
                      ? "#808080"
                      : "#154063",
                  border: params.row.s3Location == undefined ||
                    params.row.s3Location == ""
                    ? "0.125rem solid #808080" : "0.125rem solid #154063",
                  cursor:
                    params.row.s3Location == undefined ||
                      params.row.s3Location == ""
                      ? "initial"
                      : "pointer",
                }}
                disabled={
                  params.row.s3Location == undefined ||
                    params.row.s3Location == ""
                    ? true
                    : false
                }
                onClick={() => {
                  downloadReport(params.row.s3Location);
                }}
              >
                DOWNLOAD
              </button>
            </span>
          </LightTooltip>
        );
      },
    },
  ];
  const cmmColumns = [
    {
      field: "date",
      headerName: "Date",
      minWidth: 100,
      flex: 1,
      headerClassName: "header-blue",
      headerAlign: "center",
      align: "center",
      sortable: false,
      cellClassName: "no-border-left",
      renderCell: (params) => {
        return <>{params.row.date}</>;
      },
    },
    {
      field: "commentBy",
      headerName: "Comment By",
      minWidth: 150,
      flex: 1.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        // console.log("PARAMS>>>", params.row.sebi_comments ? true: false)
        return (
          <>
            {params.row.sebi_comments ? "SEBI" : "PMS"}
          </>
        );
      },
    },

    {
      field: "comment",
      headerName: "Comments",
      minWidth: 300,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params) => {
        return (
          <div
            style={{
              minHeight: "2rem",
              maxHeight: "5rem",
              padding: "5px",
              whiteSpace: "pre-wrap",
              overflow: "auto",
            }}
          >
            {params.row.pms_comments
              ? params.row.pms_comments : params.row.sebi_comments}
          </div>
        );
      },
    },
    {
      field: "downloadSupportDoc",
      headerName: "",
      minWidth: 200,
      flex: 0.5,
      align: "center",
      headerClassName: "header-blue",
      headerAlign: "center",
      sortable: false,
      renderCell: (params, index) => {
        return (
          <LightTooltip
            title={
              params.row.s3Location == undefined || params.row.s3Location == ""
                ? "No Files attached."
                : ""
            }
          >
            <span>
              <button
                className={Styles.Preview}
                key={index}
                style={{
                  backgroundColor:
                    params.row.s3Location == undefined ||
                      params.row.s3Location == ""
                      ? "#808080"
                      : "#154063",
                  border: params.row.s3Location == undefined ||
                    params.row.s3Location == ""
                    ? "0.125rem solid #808080" : "0.125rem solid #154063",
                  cursor:
                    params.row.s3Location == undefined ||
                      params.row.s3Location == ""
                      ? "initial"
                      : "pointer",
                }}
                disabled={
                  params.row.s3Location == undefined ||
                    params.row.s3Location == ""
                    ? true
                    : false
                }
                onClick={() => {
                  downloadReport(params.row.s3Location, params.row.uploadedfileName);
                }}
              >
                DOWNLOAD
              </button>
            </span>
          </LightTooltip>
        );
      },
    },
  ];

  const alertViewPayload = {
    fy_year:fy_year,
    quarter: quarter,
    pmsName: pmsName,
    ticketid: SEBITrackerPageData.ticketID,
    moduleType: moduleType,
    authToken: ls.get("authToken"),
    refreshToken: ls.get("refreshToken"),
  };

  const cmmViewPayload = {
    fy_year: SEBITrackerPageData.fy_year,
    quarter: SEBITrackerPageData.quarter,
    pmsName: pmsName,
    cmm_id: SEBITrackerPageData.id,
    particulars: SEBITrackerPageData.particulars,
    moduleType: moduleType,
    authToken: ls.get("authToken"),
    refreshToken: ls.get("refreshToken"),
  };

  const viewPageFetch = async () => {
    dispatch({ type: "SHOW_LOADER" })
    if (moduleType == "ALERT") {
      const encryptedPayload = await encrypt(alertViewPayload);
      axios
        .post(
          "/api/pms/viewPageFetchAPI",
          { payload: encryptedPayload },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          dispatch({ type: "HIDE_LOADER" });
          setRows(response.data.data.alert_remarks);
        })
        .catch((err) => {
          setOpenModal(false);
          dispatch({ type: "HIDE_LOADER" });
          errorHandler(err, dispatch);
        });
    } else if (moduleType == "CMM" || selectedReportType == "CMM") {
      const encryptedPayload = await encrypt(cmmViewPayload);
      axios
        .post(
          "/api/pms/viewPageFetchAPI",
          { payload: encryptedPayload },
          {
            withCredentials: true,
          }
        )
        .then((response) => {
          dispatch({ type: "HIDE_LOADER" });
          setComplianceType(response?.data.data.compliance_status);
          setRows(response?.data.data.cmm_remarks);
        })
        .catch((err) => {
          setOpenModal(false);
          dispatch({ type: "HIDE_LOADER" });
          errorHandler(err, navigate);
        });
    } 
  };

  useEffect(() => {
    viewPageFetch();
  }, []);

  return (
    <Dialog
      fullWidth
      maxWidth="lg"
      open={openModal}
      onClose={() => setOpenModal(false)}
      aria-labelledby="alert-dialog-title"
      aria-describedby="alert-dialog-description"
      PaperProps={{
        sx: {
          height: "80%",
        },
      }}
    >
      <DialogTitle
        sx={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <span>Comments</span>
        <div className="closeIcon" onClick={() => setOpenModal(false)}>
          <CloseIcon
            sx={{ cursor: "pointer", "&:hover": { color: "#ff0000" } }}
          />
        </div>
      </DialogTitle>
      <Loader />
      <DialogContent
        sx={{
          display: "flex",
          alignItems: "center",
          flexDirection: "column",
          gap: "1rem",
        }}
      >
        <div style={{ height: "100%", width: "100%" }}>
          <DataGrid
            getRowId={(row) => row.index}
            rows={rows}
            columns={moduleType=='ALERT' ? alertColumns:cmmColumns}
            getRowHeight={() => "auto"}
            getRowClassName={(params) => params.row.status == 'closed' ? DataGridStyles.closedRow : ''}
            disableColumnHover={(params) => params.row.status == "closed"}
            sx={{
              width: "100%",
              "& .MuiDataGrid-columnHeaderTitleContainer": {
                justifyContent: "center",
              },
              "& .MuiDataGrid-cellContent": {
                fontSize: "0.8rem",
              },
              "& .MuiDataGrid-withBorderColor": {
                borderRight: "none",
              },
              "& .MuiDataGrid-columnSeparator--sideRight": { display: "none" },
              "& .MuiDataGrid-virtualScroller::-webkit-scrollbar": {
                display: "none",
              },
              "& .MuiDataGrid-columnHeaders": { width: "fit-content" },
              "& .MuiDataGrid-cell": {
                whiteSpace: "normal",
                wordWrap: "break-word",
              },
              "&.MuiDataGrid-root--densityCompact .MuiDataGrid-cell": {
                py: "5px",
              },
              "&.MuiDataGrid-root--densityStandard .MuiDataGrid-cell": {
                py: "8px",
              },
              "&.MuiDataGrid-root--densityComfortable .MuiDataGrid-cell": {
                py: "15px",
              },
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
};

export default ViewHistory;
